import React from "react";
import PropTypes from "prop-types";
import InputLabel from "@material-ui/core/InputLabel";

const Label = ({ label, id }) => (label ? <InputLabel htmlFor={id}>{label}</InputLabel> : null);

Label.propTypes = {
  /**
   * Etiqueta para el campo
   */
  label: PropTypes.string,
  /**
   * Id del selector
   */
  id: PropTypes.string.isRequired,
};

export default Label;
